module.exports = __webpack_public_path__ + "static/Slide03@2x.f188174f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Slide03@2x.png
// module id = 709
// module chunks = 216210090109534